/**
 * Helper para validar y extraer variables de entorno requeridas
 */
const getEnvVar = (key, defaultValue = undefined) => {
  const value = process.env[key] || defaultValue;

  if (value === undefined) {
    console.error(`⚠️ [ENV WARNING]: La variable de entorno '${key}' no está definida.`);
  }

  return value;
};

/**
 * Procesa la Private Key en formato PEM:
 * Reemplaza saltos de línea escapados (\\n) por saltos de línea reales (\n)
 */
const sanitizePrivateKey = (rawKey) => {
  if (!rawKey) return "";
  return rawKey.replace(/\\n/g, "\n").trim();
};

/**
 * Objeto de Configuración Global de Entorno
 */
export const env = Object.freeze({
  // Entorno de ejecución
  NODE_ENV: process.env.NODE_ENV || "development",
  IS_DEV: process.env.NODE_ENV === "development",
  IS_PROD: process.env.NODE_ENV === "production",

  // Endpoints de API
  API_URL: getEnvVar(
    "REACT_APP_API_URL",
    "http://127.0.0.1:5001/leidenfrost-web/us-central1/app"
  ),

  // Master Service Account (M2M Auth) - Mapeo 1:1 con .env.local
  MASTER_SA_TYPE: getEnvVar("REACT_APP_TYPE", "service_account"),
  MASTER_SA_CLIENT_ID: getEnvVar("REACT_APP_CLIENT_ID", "sa_master_messiah"),
  MASTER_SA_CLIENT_EMAIL: getEnvVar("REACT_APP_CLIENT_EMAIL", "master-cms@leidenfrost.io"),
  MASTER_SA_KEY_ID: getEnvVar("REACT_APP_PRIVATE_KEY_ID", "key_master_e11f32e2"),
  MASTER_SA_SCOPES: getEnvVar("REACT_APP_SCOPES", "*").split(",").map((s) => s.trim()),
  MASTER_SA_PRIVATE_KEY: sanitizePrivateKey(
    getEnvVar("REACT_APP_PRIVATE_KEY", "")
  ),

  // Identificador de Aplicación por defecto
  DEFAULT_APP_ID: getEnvVar("REACT_APP_DEFAULT_APP_ID", "app_cms_master"),
});

/**
 * Validador de inicio de aplicación
 */
export const validateEnv = () => {
  const missing = [];

  if (!env.MASTER_SA_PRIVATE_KEY) missing.push("REACT_APP_PRIVATE_KEY");
  if (!env.MASTER_SA_CLIENT_ID) missing.push("REACT_APP_CLIENT_ID");
  if (!env.MASTER_SA_KEY_ID) missing.push("REACT_APP_PRIVATE_KEY_ID");

  if (missing.length > 0 && env.IS_DEV) {
    console.warn(
      `🚨 [ENV CHECK]: Faltan las siguientes variables de entorno en .env.local:\n - ${missing.join("\n - ")}`
    );
  }
};